/**
 * Centralized storage keys for localStorage
 * All storage keys used across the application should be defined here
 */
export const STORAGE_KEYS = {
  authToken: 'token',
  userRole: 'userRole',
  applicantId: 'applicantId',
  fileAccessToken: 'file_access_token',
  invitationData: 'invitationData',
  inviteCode: 'inviteCode',
  preferredLanguage: 'preferredLanguage',
} as const

/**
 * Type for storage key names
 */
export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS]
